export const API_URL = {
  TESTS: {
    CREATE: 'ccs/v1/tests',
    GET_ALL: 'ccs/v1/tests',
    GET_TEST_BY_ID: 'ccs/v1/tests/{id}',
    UPDATE: 'ccs/v1/tests/{id}',
    CALCULATE: 'ccs/calculate',
    RESULT: 'ccs/v1/tests/{id}/result',
    PATIENT_REPORT_DOWNLOAD: 'ccs/v1/tests/{id}/patient-report/download',
    BULK_DELETE: 'ccs/v1/tests/bulk',
    HANDOFF: 'ccs/v1/tests/handoff',
    METADATA: 'lookups/test-metadata',
  },
  CCS_MODEL: {
    CALCULATE: 'ccs/calculate',
  },
  ONBOARDING: {
    EMAIL_VALIDATION: 'users/validate',
    SEND_MAGIC_LINK: 'auth/magic-links',
    VERIFY_TOKEN: 'auth/magic-links/verify',
    VALIDATE_USER_INFORMATION: 'users/validate-info',
    SEND_CODE: 'users/send-code',
    VERIFY_CODE: 'users/verify-code',
    RESEND_CODE: 'users/resend-code',
    CREATE_USER: 'users/create',
    COUNTRIES: 'lookups/countries',
    SPECIALTIES: 'lookups/specialties',
    LOGOUT: 'auth/logout',
  },
  AUTH: {
    LOGIN: 'auth/login',
    CHANGE_PASSWORD: 'auth/change-password',
    SET_PASSWORD: 'auth/set-password',
    FORGOT_PASSWORD: 'auth/forgot-password',
    RESET_PASSWORD: 'auth/reset-password',
    REFRESH: 'auth/refresh',
  },
  USERS: {
    GET_PROFILE: 'users/profile',
    PUT_PROFILE: 'users/profile',
    PUT_LAB_UNITS: 'users/profile/lab-units',
    GET_ROLES: 'users/roles',
    PUT_WORKSPACE_REGION: 'users/workspace/region',
    PUT_BILLING: 'users/me/billing',
  },
  MEMBERS: {
    GET_ALL: 'Users/members',
    CREATE: 'Users/members',
    UPDATE_ROLE: 'Users/{userId}/members/{role}',
    DELETE: 'Users/{userId}/members',
    UPDATE_SPECIALTY: 'Users/update-specialty/{specialtyId}',
  },
  INVITATIONS: {
    LOOKUP: 'Users/invitations/lookup',
    ACCEPT: 'Users/invitations/accept',
    REVOKE: 'Users/invitations/{id}',
    RESEND: 'Users/invitations/{id}/resend',
  },
  ORGANIZATION_AUTH: {
    AUTHENTICATE: 'organization-auth/authenticate',
  },
  TENANT_API_ACCESS: {
    GET: 'tenant/api-access',
    ROTATE_SECRET: 'tenant/api-access/rotate-secret',
  },
  SALES: {
    CONTACT_REQUESTS: 'sales-contact-requests',
    CONTACT_REQUESTS_MINE: 'sales-contact-requests/mine',
  },
  PHASE_RENEWALS: 'phase-renewals',
  PHASE_RENEWALS_MINE: 'phase-renewals/mine',
  SU: {
    TESTS: 'su/tests',
    TESTS_EXPORT_CSV: 'su/tests/export/csv',
    CUSTOMERS_SEARCH: 'su/tests/customers/search',
    USERS: 'su/users',
    USER_BY_ID: 'su/users/{id}',
    USER_DEACTIVATE: 'su/users/{id}/deactivate',
    USER_RESEND_PASSWORD: 'su/users/{id}/resend-password',
    SALES_CONTACT_REQUESTS: 'su/sales-contact-requests',
    SALES_CONTACT_REQUEST_BY_ID: 'su/sales-contact-requests/{id}',
    SALES_CONTACT_REQUEST_APPROVE: 'su/sales-contact-requests/{id}/approve',
    SALES_CONTACT_REQUEST_DENY: 'su/sales-contact-requests/{id}/deny',
    EXPORT_ABANINJA_CUSTOMERS: 'su/export/abaninja/customers',
    EXPORT_ABANINJA_INVOICES: 'su/export/abaninja/invoices',
    PHASE_RENEWALS: 'su/phase-renewals',
    PHASE_RENEWAL_BY_ID: 'su/phase-renewals/{id}',
    PHASE_RENEWAL_APPROVE: 'su/phase-renewals/{id}/approve',
    PHASE_RENEWAL_DENY: 'su/phase-renewals/{id}/deny',
    API_CLIENTS: 'su/api-clients',
    API_CLIENT_BY_ID: 'su/api-clients/{id}',
    API_CLIENT_ROTATE_SECRET: 'su/api-clients/{id}/rotate-secret',
    API_CLIENT_SEND_ACCESS_EMAIL: 'su/api-clients/{id}/send-access-email',
  },
};
